module.exports = __webpack_public_path__ + "media/images/ellipse-28@2x-a35a45f079f19f5ebd64f6b77ba10837.png";